// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".richText .preview{background-color:#fcfcfc;border:1px solid #d6d6d6;border-radius:0;color:#333;height:40px;left:-46px;padding-left:10px;position:relative;top:40px;width:47px}.HTML-Container .ivu-modal-body{line-height:30px;overflow:auto}.HTML-Container .ivu-modal-body .image,.HTML-Container .ivu-modal-body img{max-width:1200px}.HTML-Container .ivu-modal-body .image-style-align-center{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
